// import React, { useState, useEffect } from "react";
// import Cookies from "js-cookie";
// import { Modal, Table, Form, Button } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import InformationModal from "../components/InformationModal";
// import styles from "./EventHandle.module.css";

// const EventHandle = () => {
//   const [events, setEvents] = useState([]);
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [mappedUsers, setMappedUsers] = useState([]);
//   const [uploadedUsers, setUploadedUsers] = useState([]);
//   const [mappedCars, setMappedCars] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isCarsModalOpen, setIsCarsModalOpen] = useState(false);
//   const [activeTab, setActiveTab] = useState("delete");
//   const [communityNo, setCommunityNo] = useState(null);
//   const [selectedMappedUsers, setSelectedMappedUsers] = useState([]);
//   const [selectedUploadedUsers, setSelectedUploadedUsers] = useState([]);
//   const [isButtonVisible, setIsButtonVisible] = useState(false);
//   const [nameSearch, setNameSearch] = useState('');
//   const [contactSearch, setContactSearch] = useState('');
//   const [addressSearch, setAddressSearch] = useState('');
//   const [searchColumn, setSearchColumn] = useState(null);
//   const [message, setMessage] = useState("");
//   const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
//   const [modalMessage, setModalMessage] = useState("");

//   const openInfoModal = () => setIsInfoModalOpen(true);
//   const closeInfoModal = () => setIsInfoModalOpen(false);

//   useEffect(() => {
//     const communityNumber = Cookies.get("adminCommunityNO");
//     setCommunityNo(communityNumber);
//     fetchEvents();
//   }, []);

//   const unmapCarFromEvent = async (carId) => {
//     try {
//       await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/unmap-car?eventId=${selectedEvent.eventId}&auctionListId=${carId}`,
//         {
//           method: "DELETE",
//           credentials: "include",
//           headers: {
//             "Content-Type": "application/json",
//             "X-Full-URL": window.location.href,
//           },
//         }
//       );
//       openCarsModal(selectedEvent);
//       setIsInfoModalOpen(true);
//       setModalMessage("Car un-mapped successfully");
//     } catch (error) {
//       console.error("Error removing car from event:", error);
//       setMessage("Failed to remove car from event");
//     }
//   };

//   const fetchEvents = async () => {
//     const communityNumber = Cookies.get("adminCommunityNO");
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/events?communityNo=${communityNumber}`,
//         { credentials: "include", headers: { "X-Full-URL": window.location.href } }
//       );
//       const data = await response.json();
//       setEvents(data);
//     } catch (error) {
//       console.error("Error fetching events:", error);
//     }
//   };

//   const openModal = async (event) => {
//     setSelectedEvent(event);
//     try {
//       const mappedResponse = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/mapped-users?eventId=${event.eventId}`,
//         { credentials: "include", headers: { "X-Full-URL": window.location.href } }
//       );
//       const uploadedResponse = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/uploaded-users?communityNo=${communityNo}&eventId=${event.eventId}`,
//         { credentials: "include", headers: { "X-Full-URL": window.location.href } }
//       );
//       const mappedData = await mappedResponse.json();
//       setMappedUsers(mappedData);
//       const uploadedData = await uploadedResponse.json();
//       setUploadedUsers(uploadedData);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//     setIsModalOpen(true);
//   };

//   const openCarsModal = async (event) => {
//     setSelectedEvent(event);
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/mapped-cars?eventId=${event.eventId}`,
//         { credentials: "include", headers: { "X-Full-URL": window.location.href } }
//       );
//       const data = await response.json();
//       setMappedCars(data);
//     } catch (error) {
//       console.error("Error fetching mapped cars:", error);
//     }
//     setIsCarsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setSelectedEvent(null);
//     setActiveTab("delete");
//     setSelectedMappedUsers([]);
//     setSelectedUploadedUsers([]);
//     setIsButtonVisible(false);
//     setMessage("");
//   };

//   const closeCarsModal = () => {
//     setIsCarsModalOpen(false);
//     setSelectedEvent(null);
//     setMessage("");
//   };

//   const handleMappedUserSelect = (userId) => {
//     setSelectedMappedUsers(prev =>
//       prev.includes(userId) ? prev.filter(id => id !== userId) : [...prev, userId]
//     );
//     setIsButtonVisible(true);
//   };

//   const handleUploadedUserSelect = (userId) => {
//     setSelectedUploadedUsers(prev =>
//       prev.includes(userId) ? prev.filter(id => id !== userId) : [...prev, userId]
//     );
//     setIsButtonVisible(true);
//   };

//   const handleTabChange = (tab) => {
//     setActiveTab(tab);
//     setIsButtonVisible(false);
//     setSelectedMappedUsers([]);
//     setSelectedUploadedUsers([]);
//     setMessage("");
//   };

//   const removeSelectedUsersFromEvent = async () => {
//     try {
//       await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/mapped-users/delete`,
//         {
//           method: "DELETE",
//           credentials: "include",
//           headers: { "Content-Type": "application/json", "X-Full-URL": window.location.href },
//           body: JSON.stringify({ eventId: selectedEvent.eventId, userIds: selectedMappedUsers }),
//         }
//       );
//       setMappedUsers(mappedUsers.filter(user => !selectedMappedUsers.includes(user.id)));
//       openModal(selectedEvent);
//       setSelectedMappedUsers([]);
//       setIsButtonVisible(false);
//       setIsInfoModalOpen(true);
//       setModalMessage("Selected Customer(s) deleted from event.");
//     } catch (error) {
//       console.error("Error removing users:", error);
//     }
//   };

//   const addSelectedUsersToEvent = async () => {
//     try {
//       await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/mapped-users/add`,
//         {
//           method: "POST",
//           credentials: "include",
//           headers: { "Content-Type": "application/json", "X-Full-URL": window.location.href },
//           body: JSON.stringify({ eventId: selectedEvent.eventId, userIds: selectedUploadedUsers }),
//         }
//       );
//       setUploadedUsers(uploadedUsers.filter(user => !selectedUploadedUsers.includes(user.LenderBuyerId)));
//       setSelectedUploadedUsers([]);
//       setIsButtonVisible(false);
//       openModal(selectedEvent);
//       setIsInfoModalOpen(true);
//       setModalMessage("Selected Customer(s) added to event.");
//     } catch (error) {
//       console.error("Error adding users:", error);
//     }
//   };

//   const filteredUploadedUsers = uploadedUsers.filter(
//     (user) =>
//       (searchColumn === 'name' ? user.name.toLowerCase().includes(nameSearch.toLowerCase()) : true) &&
//       (searchColumn === 'contact' ? user.PrimaryPhone.includes(contactSearch) : true) &&
//       (searchColumn === 'address' ? user.ContactAddress.toLowerCase().includes(addressSearch.toLowerCase()) : true)
//   );

//   const filteredMappedUsers = mappedUsers.filter(
//     (user) =>
//       (searchColumn === 'name' ? user.customer_name.toLowerCase().includes(nameSearch.toLowerCase()) : true) &&
//       (searchColumn === 'contact' ? user.customer_contactnumber.includes(contactSearch) : true)
//   );

//   return (
//     <div className={styles.container}>
//       <InformationModal isOpen={isInfoModalOpen} onClose={closeInfoModal} message={modalMessage} />
//       <div className={styles.header}>
//         <p>Event Management</p>
//       </div>
//       <div className={styles.tableContainer}>
//         <table className="table table-striped">
//           <thead>
//             <tr>
//               <th>Event Title</th>
//               <th>Location</th>
//               <th>Start Date</th>
//               <th>End Date</th>
//               <th>Actions</th>
//               <th>View Cars</th>
//             </tr>
//           </thead>
//           <tbody>
//             {events.map((event) => (
//               <tr key={event.eventId}>
//                 <td>{event.eventTitle}</td>
//                 <td>{event.location}</td>
//                 <td>{new Date(event.startDateAndTime).toLocaleString()}</td>
//                 <td>{new Date(event.endDateAndTime).toLocaleString()}</td>
//                 <td><Button variant="danger" onClick={() => openModal(event)}>View Customers</Button></td>
//                 <td><Button variant="outline-danger" onClick={() => openCarsModal(event)}>View Cars</Button></td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <Modal show={isModalOpen} onHide={closeModal} size="lg" className={styles.modalCustom}>
//         <Modal.Header className={styles.modalHeader}>
//           <Modal.Title className={styles.modalTitle}>Manage Customer - {selectedEvent?.eventTitle}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className={styles.modalBody}>
//           <ul className="nav nav-tabs">
//             <li className="nav-item">
//               <button className={`nav-link ${activeTab === "add" ? "active" : ""}`} onClick={() => setActiveTab("add")}>Add Customers</button>
//             </li>
//             <li className="nav-item">
//               <button className={`nav-link ${activeTab === "delete" ? "active" : ""}`} onClick={() => setActiveTab("delete")}>Delete Customers</button>
//             </li>
//           </ul>
//           {activeTab === "delete" && (
//             <div className={styles.tableScroll}>
//               <Table striped bordered hover className="mt-3">
//                 <thead>
//                   <tr>
//                     <th>
//                       <div className={styles.searchContainer}>
//                         <span>Name</span>
//                         <input type="text" placeholder="Search..." value={nameSearch} onChange={(e) => { setNameSearch(e.target.value); setSearchColumn("name"); }} />
//                       </div>
//                     </th>
//                     <th>
//                       <div className={styles.searchContainer}>
//                         <span>Contact</span>
//                         <input type="text" placeholder="Search..." value={contactSearch} onChange={(e) => { setContactSearch(e.target.value); setSearchColumn("contact"); }} />
//                       </div>
//                     </th>
//                     <th>Select</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredMappedUsers.map((user) => (
//                     <tr key={user.id}>
//                       <td>{user.customer_name}</td>
//                       <td>{user.customer_contactnumber}</td>
//                       <td>
//                         <Form.Check className={styles.customCheckbox} type="checkbox" checked={selectedMappedUsers.includes(user.id)} onChange={() => handleMappedUserSelect(user.id)} />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//           )}
//           {activeTab === "add" && (
//             <div className={styles.tableScroll}>
//               <Table striped bordered hover className="mt-3">
//                 <thead>
//                   <tr>
//                     <th>
//                       <div className={styles.searchContainer}>
//                         <span>Name</span>
//                         <input type="text" placeholder="Search..." value={nameSearch} onChange={(e) => { setNameSearch(e.target.value); setSearchColumn("name"); }} />
//                       </div>
//                     </th>
//                     <th>
//                       <div className={styles.searchContainer}>
//                         <span>Contact</span>
//                         <input type="text" placeholder="Search..." value={contactSearch} onChange={(e) => { setContactSearch(e.target.value); setSearchColumn("contact"); }} />
//                       </div>
//                     </th>
//                     <th>Select</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredUploadedUsers.map((user) => (
//                     <tr key={user.LenderBuyerId}>
//                       <td>{user.name}</td>
//                       <td>{user.PrimaryPhone}</td>
//                       <td>
//                         <Form.Check className={styles.customCheckbox} type="checkbox" checked={selectedUploadedUsers.includes(user.LenderBuyerId)} onChange={() => handleUploadedUserSelect(user.LenderBuyerId)} />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           {activeTab === "delete" ? (
//             <Button variant="danger" onClick={removeSelectedUsersFromEvent} disabled={selectedMappedUsers.length === 0}>Delete Selected</Button>
//           ) : (
//             <Button variant="danger" onClick={addSelectedUsersToEvent} disabled={selectedUploadedUsers.length === 0}>Add Selected</Button>
//           )}
//           <Button variant="outline-danger" onClick={closeModal}>Close</Button>
//         </Modal.Footer>
//       </Modal>
//       <Modal style={{marginTop:"10vh"}} show={isCarsModalOpen} onHide={closeCarsModal} size="lg" className={styles.modalCustom}>
//         <div className={styles.carsModalHeader}>
//           <h3>Mapped Cars for Event: {selectedEvent?.eventTitle}</h3>
//         </div>
//         <Modal.Body className={styles.carsModalBody}>
//           <div className="row">
//             {mappedCars.length > 0 ? (
//               mappedCars.map((car) => (
//                 <div key={car.auctionListId} className="col-md-12 mb-3">
//                   <div className={styles.card}>
//                     <div className={styles.cardContent}>
//                       <div className={styles.cardImageContainer}>
//                         <div className={styles.cardImage} style={{ backgroundImage: car.images?.[0] ? `url(${car.images[0]})` : "" }}></div>
//                       </div>
//                       <div className={styles.cardTextContainer}>
//                         <div className={styles.cardText}>
//                           <span>{car.MakeAndModel}</span>
//                           <span>{car.variant || "N/A"}</span>
//                           <span>{car.body || "N/A"}</span>
//                         </div>
//                         <div className={styles.cardText}>
//                           <p><span>{car.location || "N/A"}</span></p>
//                         </div>
//                         <div className={styles.cardText}>
//                           <span>₹{car.StartPrice?.toLocaleString() || "N/A"}</span>
//                         </div>
//                         {/* <div>
//                           <Button variant="danger" size="sm" onClick={() => unmapCarFromEvent(car.AuctionListId)}>&#11199;</Button>
//                         </div> */}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 ))
//               ) : (
//                 <div className={styles.noCars}>No cars mapped to this event.</div>
//               )}
//           </div>
//         </Modal.Body>
//         <Modal.Footer className={styles.modalFooter}>
//           <Button variant="danger" onClick={closeCarsModal}>Close</Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default EventHandle;

import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Modal, Table, Form, Button, Nav } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import InformationModal from "../components/InformationModal";
import styles from "./EventHandle.module.css";
import * as XLSX from "xlsx";

const EventHandle = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [mappedUsers, setMappedUsers] = useState([]);
  const [uploadedUsers, setUploadedUsers] = useState([]);
  const [mappedCars, setMappedCars] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCarsModalOpen, setIsCarsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("delete");
  const [addCustomerSubTab, setAddCustomerSubTab] = useState("existing");
  const [communityNo, setCommunityNo] = useState(null);
  const [selectedMappedUsers, setSelectedMappedUsers] = useState([]);
  const [selectedUploadedUsers, setSelectedUploadedUsers] = useState([]);
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const [nameSearch, setNameSearch] = useState("");
  const [contactSearch, setContactSearch] = useState("");
  const [searchColumn, setSearchColumn] = useState(null);
  const [message, setMessage] = useState("");
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [users, setUsers] = useState([]);
  const [manualName, setManualName] = useState("");
  const [manualPhone, setManualPhone] = useState("");
  const [manualEmail, setManualEmail] = useState("");
  const [manualUsers, setManualUsers] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const openInfoModal = () => setIsInfoModalOpen(true);
  const closeInfoModal = () => setIsInfoModalOpen(false);

  useEffect(() => {
    const communityNumber = Cookies.get("adminCommunityNO");
    setCommunityNo(communityNumber);
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    const communityNumber = Cookies.get("adminCommunityNO");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/events?communityNo=${communityNumber}`,
        {
          credentials: "include",
          headers: { "X-Full-URL": window.location.href },
        }
      );
      const data = await response.json();
      setEvents(data);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const openModal = async (event) => {
    setSelectedEvent(event);
    try {
      const mappedResponse = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/mapped-users?eventId=${event.eventId}`,
        {
          credentials: "include",
          headers: { "X-Full-URL": window.location.href },
        }
      );
      const uploadedResponse = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/uploaded-users?communityNo=${communityNo}&eventId=${event.eventId}`,
        {
          credentials: "include",
          headers: { "X-Full-URL": window.location.href },
        }
      );
      const mappedData = await mappedResponse.json();
      setMappedUsers(mappedData);
      const uploadedData = await uploadedResponse.json();
      setUploadedUsers(uploadedData);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
    setIsModalOpen(true);
  };

  const openCarsModal = async (event) => {
    setSelectedEvent(event);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/mapped-cars?eventId=${event.eventId}`,
        {
          credentials: "include",
          headers: { "X-Full-URL": window.location.href },
        }
      );
      const data = await response.json();
      setMappedCars(data);
    } catch (error) {
      console.error("Error fetching mapped cars:", error);
    }
    setIsCarsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedEvent(null);
    setActiveTab("delete");
    setAddCustomerSubTab("existing");
    setSelectedMappedUsers([]);
    setSelectedUploadedUsers([]);
    setIsButtonVisible(false);
    setMessage("");
    setUsers([]);
    setManualUsers([]);
  };

  const closeCarsModal = () => {
    setIsCarsModalOpen(false);
    setSelectedEvent(null);
    setMessage("");
  };

  const handleMappedUserSelect = (userId) => {
    setSelectedMappedUsers((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
    setIsButtonVisible(true);
  };

  const handleUploadedUserSelect = (userId) => {
    setSelectedUploadedUsers((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
    setIsButtonVisible(true);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setIsButtonVisible(false);
    setSelectedMappedUsers([]);
    setSelectedUploadedUsers([]);
    setMessage("");
  };

  const handleAddCustomerSubTabChange = (subTab) => {
    setAddCustomerSubTab(subTab);
    setIsButtonVisible(false);
    setSelectedUploadedUsers([]);
    setMessage("");
  };

  const removeSelectedUsersFromEvent = async () => {
    try {
      await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/mapped-users/delete`,
        {
          method: "DELETE",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href,
          },
          body: JSON.stringify({
            eventId: selectedEvent.eventId,
            userIds: selectedMappedUsers,
          }),
        }
      );
      setMappedUsers(
        mappedUsers.filter((user) => !selectedMappedUsers.includes(user.id))
      );
      openModal(selectedEvent);
      setSelectedMappedUsers([]);
      setIsButtonVisible(false);
      setIsInfoModalOpen(true);
      setModalMessage("Selected Customer(s) deleted from event.");
    } catch (error) {
      console.error("Error removing users:", error);
    }
  };

  const addSelectedUsersToEvent = async () => {
    try {
      await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/mapped-users/add`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href,
          },
          body: JSON.stringify({
            eventId: selectedEvent.eventId,
            userIds: selectedUploadedUsers,
          }),
        }
      );
      setUploadedUsers(
        uploadedUsers.filter(
          (user) => !selectedUploadedUsers.includes(user.LenderBuyerId)
        )
      );
      setSelectedUploadedUsers([]);
      setIsButtonVisible(false);
      openModal(selectedEvent);
      setIsInfoModalOpen(true);
      setModalMessage("Selected Customer(s) added to event.");
    } catch (error) {
      console.error("Error adding users:", error);
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      if (rawData.length < 2) {
        setErrorMessage("No valid data found in the Excel file.");
        return;
      }
      const headers = rawData[0].map((h) => String(h).toLowerCase().trim());
      const nameIndex = headers.findIndex((h) =>
        ["name", "customer name"].includes(h)
      );
      const phoneIndex = headers.findIndex((h) =>
        ["phone", "phone number", "contact", "mobile"].includes(h)
      );
      const emailIndex = headers.findIndex((h) =>
        ["email", "email id", "e-mail"].includes(h)
      );
      if (nameIndex === -1 || phoneIndex === -1) {
        setErrorMessage(
          "Excel file must contain 'Name' and 'Phone' columns (case-insensitive)."
        );
        return;
      }
      const parsedUsers = rawData
        .slice(1)
        .map((row) => {
          const name = row[nameIndex]?.toString().trim() || "";
          const userID = row[phoneIndex]?.toString().trim() || "";
          const email =
            emailIndex !== -1 ? row[emailIndex]?.toString().trim() || "" : "";
          return { name, userID, email };
        })
        .filter((user) => user.name && user.userID);
      if (parsedUsers.length === 0) {
        setErrorMessage("No valid users found in the Excel file.");
        return;
      }
      setUsers(parsedUsers);
      setErrorMessage("");
    };
    reader.readAsArrayBuffer(file);
  };

  const removeUser = (index) => {
    setUsers(users.filter((_, i) => i !== index));
  };

  const addManualUser = () => {
    if (!manualName || !manualPhone) {
      setErrorMessage("Name and Phone Number are required.");
      return;
    }
    setManualUsers([
      ...manualUsers,
      { name: manualName, userID: manualPhone, email: manualEmail },
    ]);
    setManualName("");
    setManualPhone("");
    setManualEmail("");
    setErrorMessage("");
  };

  const removeManualUser = (index) => {
    setManualUsers(manualUsers.filter((_, i) => i !== index));
  };

  const submitUsers = async () => {
    const allUsers = [...users, ...manualUsers];
    if (allUsers.length === 0) {
      setErrorMessage("No users to submit.");
      return;
    }
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/lender-events/map-users`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href,
          },
          body: JSON.stringify({
            eventId: selectedEvent.eventId,
            communityNo: communityNo,
            preapprovedLimit: 999999,
            users: allUsers,
          }),
        }
      );
      const data = await response.json();
      setIsInfoModalOpen(true);
      setModalMessage(data.message || "Users mapped to event successfully!");
      setUsers([]);
      setManualUsers([]);
      openModal(selectedEvent);
    } catch (error) {
      console.error("Error mapping users:", error);
      setErrorMessage("Failed to map users to event.");
    }
  };

  const filteredUploadedUsers = uploadedUsers.filter(
    (user) =>
      (searchColumn === "name"
        ? user.name.toLowerCase().includes(nameSearch.toLowerCase())
        : true) &&
      (searchColumn === "contact"
        ? user.PrimaryPhone.includes(contactSearch)
        : true)
  );

  const filteredMappedUsers = mappedUsers.filter(
    (user) =>
      (searchColumn === "name"
        ? user.customer_name.toLowerCase().includes(nameSearch.toLowerCase())
        : true) &&
      (searchColumn === "contact"
        ? user.customer_contactnumber.includes(contactSearch)
        : true)
  );

  return (
    <div className={styles.container}>
      <InformationModal
        isOpen={isInfoModalOpen}
        onClose={closeInfoModal}
        message={modalMessage}
      />
      <div className={styles.header}>
        <p>Event Management</p>
      </div>
      <div className={styles.tableContainer}>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Event Title</th>
              <th>Location</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Actions</th>
              <th>View Cars</th>
            </tr>
          </thead>
          <tbody>
            {events.map((event) => (
              <tr key={event.eventId}>
                <td>{event.eventTitle}</td>
                <td>{event.location}</td>
                <td>{new Date(event.startDateAndTime).toLocaleString()}</td>
                <td>{new Date(event.endDateAndTime).toLocaleString()}</td>
                <td>
                  <Button variant="danger" onClick={() => openModal(event)}>
                    View Customers
                  </Button>
                </td>
                <td>
                  <Button
                    variant="outline-danger"
                    onClick={() => openCarsModal(event)}
                  >
                    View Cars
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Modal
        show={isModalOpen}
        onHide={closeModal}
        size="lg"
        className={styles.modalCustom}
      >
        <Modal.Header className={styles.modalHeader}>
          <Modal.Title className={styles.modalTitle}>
            Manage Customer - {selectedEvent?.eventTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "add" ? "active" : ""}`}
                onClick={() => handleTabChange("add")}
              >
                Add Customers
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "delete" ? "active" : ""}`}
                onClick={() => handleTabChange("delete")}
              >
                Delete Customers
              </button>
            </li>
          </ul>
          {activeTab === "add" && (
            <div>
              <Nav variant="tabs" className="mt-3">
                <Nav.Item>
                  <Nav.Link
                    active={addCustomerSubTab === "existing"}
                    onClick={() => handleAddCustomerSubTabChange("existing")}
                  >
                    Add Existing
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    active={addCustomerSubTab === "manual"}
                    onClick={() => handleAddCustomerSubTabChange("manual")}
                  >
                    Add New Manual
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    active={addCustomerSubTab === "excel"}
                    onClick={() => handleAddCustomerSubTabChange("excel")}
                  >
                    Add New Excel
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              {addCustomerSubTab === "existing" && (
                <div className={styles.tableScroll}>
                  <Table striped bordered hover className="mt-3">
                    <thead>
                      <tr>
                        <th>
                          <div className={styles.searchContainer}>
                            <span>Name</span>
                            <input
                              type="text"
                              placeholder="Search..."
                              value={nameSearch}
                              onChange={(e) => {
                                setNameSearch(e.target.value);
                                setSearchColumn("name");
                              }}
                            />
                          </div>
                        </th>
                        <th>
                          <div className={styles.searchContainer}>
                            <span>Contact</span>
                            <input
                              type="text"
                              placeholder="Search..."
                              value={contactSearch}
                              onChange={(e) => {
                                setContactSearch(e.target.value);
                                setSearchColumn("contact");
                              }}
                            />
                          </div>
                        </th>
                        <th>Select</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredUploadedUsers.map((user) => (
                        <tr key={user.LenderBuyerId}>
                          <td>{user.name}</td>
                          <td>{user.PrimaryPhone}</td>
                          <td>
                            <Form.Check
                              className={styles.customCheckbox}
                              type="checkbox"
                              checked={selectedUploadedUsers.includes(
                                user.LenderBuyerId
                              )}
                              onChange={() =>
                                handleUploadedUserSelect(user.LenderBuyerId)
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
              {addCustomerSubTab === "manual" && (
                <div>
                  <div style={{ marginBottom: "16px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ marginRight: "10px" }}>
                        <input
                          type="text"
                          placeholder="Name*"
                          value={manualName}
                          onChange={(e) => setManualName(e.target.value)}
                          style={{
                            padding: "8px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            width: "200px",
                          }}
                        />
                      </div>
                      <div style={{ marginRight: "10px" }}>
                        <input
                          type="text"
                          placeholder="Phone Number*"
                          value={manualPhone}
                          onChange={(e) => setManualPhone(e.target.value)}
                          style={{
                            padding: "8px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            width: "200px",
                          }}
                        />
                      </div>
                      <div style={{ marginRight: "10px" }}>
                        <input
                          type="text"
                          placeholder="Email (Optional)"
                          value={manualEmail}
                          onChange={(e) => setManualEmail(e.target.value)}
                          style={{
                            padding: "8px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            width: "200px",
                          }}
                        />
                      </div>
                      <div style={{ marginRight: "10px" }}>
                        <button
                          onClick={addManualUser}
                          style={{
                            padding: "10px 16px",
                            backgroundColor: "#007bff",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                          onMouseOver={(e) =>
                            (e.target.style.backgroundColor = "#0056b3")
                          }
                          onMouseOut={(e) =>
                            (e.target.style.backgroundColor = "#007bff")
                          }
                        >
                          Add User
                        </button>
                      </div>
                    </div>
                  </div>
                  {errorMessage && (
                    <p className="text-danger">{errorMessage}</p>
                  )}
                  {manualUsers.length > 0 && (
                    <div className={styles.tableScroll}>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Phone</th>
                            <th>Email</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {manualUsers.map((user, index) => (
                            <tr key={index}>
                              <td>{user.name}</td>
                              <td>{user.userID}</td>
                              <td>{user.email}</td>
                              <td>
                                <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={() => removeManualUser(index)}
                                >
                                  Remove
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </div>
              )}
              {addCustomerSubTab === "excel" && (
                <div>
                  <input
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={handleFileUpload}
                  />
                  {errorMessage && (
                    <p className="text-danger">{errorMessage}</p>
                  )}
                  {users.length > 0 && (
                    <div className={styles.tableScroll}>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Phone</th>
                            <th>Email</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {users.map((user, index) => (
                            <tr key={index}>
                              <td>{user.name}</td>
                              <td>{user.userID}</td>
                              <td>{user.email}</td>
                              <td>
                                <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={() => removeUser(index)}
                                >
                                  Remove
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {activeTab === "delete" && (
            <div className={styles.tableScroll}>
              <Table striped bordered hover className="mt-3">
                <thead>
                  <tr>
                    <th>
                      <div className={styles.searchContainer}>
                        <span>Name</span>
                        <input
                          type="text"
                          placeholder="Search..."
                          value={nameSearch}
                          onChange={(e) => {
                            setNameSearch(e.target.value);
                            setSearchColumn("name");
                          }}
                        />
                      </div>
                    </th>
                    <th>
                      <div className={styles.searchContainer}>
                        <span>Contact</span>
                        <input
                          type="text"
                          placeholder="Search..."
                          value={contactSearch}
                          onChange={(e) => {
                            setContactSearch(e.target.value);
                            setSearchColumn("contact");
                          }}
                        />
                      </div>
                    </th>
                    <th>Select</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredMappedUsers.map((user) => (
                    <tr key={user.id}>
                      <td>{user.customer_name}</td>
                      <td>{user.customer_contactnumber}</td>
                      <td>
                        <Form.Check
                          className={styles.customCheckbox}
                          type="checkbox"
                          checked={selectedMappedUsers.includes(user.id)}
                          onChange={() => handleMappedUserSelect(user.id)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {activeTab === "add" && (
            <Button
              variant="success"
              onClick={ addCustomerSubTab == "existing" ? addSelectedUsersToEvent : submitUsers}
              disabled={
                (addCustomerSubTab === "existing" &&
                  selectedUploadedUsers.length === 0) ||
                ((addCustomerSubTab === "manual" ||
                  addCustomerSubTab === "excel") &&
                  users.length === 0 &&
                  manualUsers.length === 0)
              }
            >
              Submit
            </Button>
          )}
          {activeTab === "delete" && (
            <Button
              variant="danger"
              onClick={removeSelectedUsersFromEvent}
              disabled={selectedMappedUsers.length === 0}
            >
              Delete Selected
            </Button>
          )}
          <Button variant="outline-danger" onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={isCarsModalOpen}
        onHide={closeCarsModal}
        size="lg"
        className={styles.modalCustom}
      >
        <div className={styles.carsModalHeader}>
          <h3>Mapped Cars for Event: {selectedEvent?.eventTitle}</h3>
        </div>
        <Modal.Body className={styles.carsModalBody}>
          <div className="row">
            {mappedCars.length > 0 ? (
              mappedCars.map((car) => (
                <div key={car.auctionListId} className="col-md-12 mb-3">
                  <div className={styles.card}>
                    <div className={styles.cardContent}>
                      <div className={styles.cardImageContainer}>
                        <div
                          className={styles.cardImage}
                          style={{
                            backgroundImage: car.images?.[0]
                              ? `url(${car.images[0]})`
                              : "",
                          }}
                        ></div>
                      </div>
                      <div className={styles.cardTextContainer}>
                        <div className={styles.cardText}>
                          <span>{car.MakeAndModel}</span>
                          <span>{car.variant || "N/A"}</span>
                          <span>{car.body || "N/A"}</span>
                        </div>
                        <div className={styles.cardText}>
                          <p>
                            <span>{car.location || "N/A"}</span>
                          </p>
                        </div>
                        <div className={styles.cardText}>
                          <span>
                            ₹{car.StartPrice?.toLocaleString() || "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className={styles.noCars}>No cars mapped to this event.</div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
          <Button variant="danger" onClick={closeCarsModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EventHandle;
